import ProductPage from '../../components/pages/Product';

const Product: React.FC = () => {
  return <ProductPage isInterestProductView={false} />;
};

export default Product;
